import { render, staticRenderFns } from "./addFreightShansong.vue?vue&type=template&id=60c92bf2&scoped=true"
import script from "./addFreightShansong.vue?vue&type=script&lang=js"
export * from "./addFreightShansong.vue?vue&type=script&lang=js"
import style0 from "./addFreightShansong.vue?vue&type=style&index=0&id=60c92bf2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c92bf2",
  null
  
)

export default component.exports